import config from '@sanity/browserslist-config'

/** @public */
export const DEFAULT_BROWSERSLIST_QUERY: string[] = config
